import { createMuiTheme } from '@material-ui/core/styles'
// Pick colors on https://material.io/resources/color/#!/

export const theme = createMuiTheme({
    typography: {
        fontFamily: "'Noto sans JP', serif"
    },
    palette: {
        type: "dark",
        primary: {
            light: '#b6ffff',
            main: '#84D0D0',
            dark: '#539f9f',
            contrastText: '#fff',
        },
        secondary: {
            light: '#ffff57',
            main: '#fceb04',
            dark: '#c5b900',
            contrastText: '#000',
        },
        divider: '#777',
        text: {
            primary: '#fff',
            secondary: 'rgba(255, 255, 255, 0.7)',
            disabled: 'rgba(255, 255, 255, 0.5)',
            hint: 'rgba(255, 255, 255, 0.5)',
            icon: 'rgba(255, 255, 255, 0.5)',
        },
        grey: {
            50: '#fafafa',
            100: '#f5f5f5',
            200: '#eeeeee',
            300: '#e0e0e0',
            400: '#bdbdbd',
            500: '#9e9e9e',
            600: '#757575',
            700: '#616161',
            800: '#424242',
            900: '#212121',
            A100: '#d5d5d5',
            A200: '#aaaaaa',
            A400: '#303030',
            A700: '#616161',
        },
        background: {
            paper: '#424242',
            default: '#303030'
        },
        action: {
            active: '#fff',
            hover: 'rgba(255, 255, 255, 0.08)',
            hoverOpacity: 0.08,
            selected: 'rgba(255, 255, 255, 0.16)',
            selectedOpacity: 0.16,
            disabled: 'rgba(255, 255, 255, 0.3)',
            disabledBackground: 'rgba(255, 255, 255, 0.12)',
            disabledOpacity: 0.38,
            focus: 'rgba(255, 255, 255, 0.12)',
            focusOpacity: 0.12,
            activatedOpacity: 0.24,
        }
    },
});